import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Agreement from '@/components/Agreement'
import Share from '@/components/Share'
import Login from '@/components/Login'
import Login1 from '@/components/Login1'
import RuZhu from '@/components/RuZhu'
import ZiXun from '@/components/ZiXun'
import JiGou from '@/components/JiGou'
import JianJie from '@/components/JianJie'
import Subclass from '@/components/Subclass'
import SubclassZiXun from '@/components/SubclassZiXun'
import SubclassListInfo from '@/components/SubclassListInfo'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement
    },
    {
      path: '/share',
      name: 'share',
      component: Share
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/login1',
      name: 'login1',
      component: Login1
    },
    {
      path: '/ruZhu',
      name: 'ruZhu',
      component: RuZhu
    },
    {
      path: '/ziXun',
      name: 'ziXun',
      component: ZiXun
    },
    {
      path: '/jiGou',
      name: 'jiGou',
      component: JiGou
    },
    {
      path: '/jianJie',
      name: 'jianJie',
      component: JianJie
    },
    {
      path: '/subclass',
      name: 'subclass',
      component: Subclass
    },
    {
      path: '/subclassZiXun',
      name: 'subclassZiXun',
      component: SubclassZiXun
    },
    {
      path: '/subclassListInfo',
      name: 'subclassListInfo',
      component: SubclassListInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js